import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { useTranslation } from '@mint-lib/i18n';
import { Delete, Edit, OverflowMenuHorizontal } from '@mint-lib/icons';
import {
  Button,
  Divider,
  itemVariants,
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
  Skeleton,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { useDeleteScheduledQueries } from '../../../../hooks/useDeleteScheduledQueries.jsx';
import { useToggleScheduleDialog } from '../../../../hooks/useToggleScheduleDialog.jsx';
import { ScheduleTableType } from '../../../../types/queryScheduler.js';

const ActionCell = ({ data }: ICellRendererParams<ScheduleTableType>) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  const { setIsOpenScheduleDialog, setEditQuery } = useToggleScheduleDialog();
  const { setScheduledQueriesIds, toggleDeleteDialog } =
    useDeleteScheduledQueries();

  const handleDeleteQuery = (scheduleId: string) => {
    setScheduledQueriesIds([scheduleId]);
    toggleDeleteDialog();
  };

  if (data?.__isSkeleton) {
    return <Skeleton />;
  }

  const isEditable = data?.status !== 'expired';

  return (
    <div className="flex h-full items-center justify-center">
      <Popover>
        <PopoverTrigger asChild>
          <Button icon variant="plain" aria-label="Open chat menu">
            <OverflowMenuHorizontal />
          </Button>
        </PopoverTrigger>
        <PopoverPortal>
          <PopoverContent className="z-popover flex flex-col" align="end">
            {isEditable && (
              <>
                <Button
                  variant="text"
                  className={cn(
                    itemVariants({
                      popoverItem: 'default',
                    }),
                    'flex justify-between',
                  )}
                  onClick={() => {
                    if (data?.scheduledQueryId) {
                      setEditQuery(data.scheduledQueryId);
                      setIsOpenScheduleDialog(true);
                    }
                  }}
                >
                  {t('Edit')} <Edit />
                </Button>
                <Divider />
              </>
            )}
            <Button
              variant="text"
              className={cn(
                itemVariants({
                  popoverItem: 'default',
                }),
                'flex justify-between text-text-error',
              )}
              onClick={() => {
                if (data) {
                  handleDeleteQuery(data.scheduledQueryId);
                }
              }}
            >
              {t('Delete')} <Delete className="fill-text-error" />
            </Button>
          </PopoverContent>
        </PopoverPortal>
      </Popover>
    </div>
  );
};

export { ActionCell };
